import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";

import App from "./App.vue";
import router from "./router";
import { useQuizStore } from "@/stores/quiz";

import "./assets/main.scss";
import "./assets/pdf.scss";

const i18n = createI18n({
  // something vue-i18n options here ...
  locale: "fr-FR",
  legacy: false,
  datetimeFormats: {
    "fr-FR": {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      },
    },
  },
});

const launchQuiz = () => {
  window.scrollTo(0, 0);
  document.querySelector("body").style.overflow = "hidden";

  const app = createApp(App, document.getElementById("quiz-container").dataset);

  app.use(i18n);
  app.use(createPinia());
  app.use(router);

  const quizStore = useQuizStore();

  if (document.getElementById("quiz-container").dataset.questionId) {
    router.push({
      name: "question-preview",
      params: {
        questionId:
          document.getElementById("quiz-container").dataset.questionId,
      },
    });
  } else {
    if (quizStore.currentRoute) {
      router.push(quizStore.currentRoute);
    } else {
      router.push({ name: "home" });
    }
  }
  app.mount("#quiz-container");
};

addEventListener("popstate", (event) => {
  if (document.location.hash == "#quiz") {
    launchQuiz();
  }
});
if (document.location.hash == "#quiz") {
  launchQuiz();
}
